jQuery(document).ready(function() {

    let questionContainer = document.querySelectorAll('.faq-section__question-container-new');
    let answer = document.querySelectorAll('.faq-section__question-container__answer-new');

    for (let i = 0; i < questionContainer.length; i++) {
        answer[i].style.maxHeight = '0';

        let icon = questionContainer[i].querySelector('.faq-section__question-top img');


        questionContainer[i].addEventListener('click', () => {
            if (questionContainer[i].classList.contains('active')) {
                questionContainer[i].classList.remove('active');
                answer[i].style.maxHeight = '0';


                icon.style.transform = 'rotate(0deg)';
            } else {
                for (let j = 0; j < questionContainer.length; j++) {
                    questionContainer[j].classList.remove('active');
                    answer[j].style.maxHeight = '0';


                    let otherIcon = questionContainer[j].querySelector('.faq-section__question-top img');
                    otherIcon.style.transform = 'rotate(0deg)';
                }
                questionContainer[i].classList.add('active');
                answer[i].style.maxHeight = '100px';


                icon.style.transform = 'rotate(180deg)';
            }
        });
    }
});